import React from 'react';
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { Stack } from '@mui/material';
import { DiscountTypes } from 'api';
import ChannelBlock from './ChannelBlock';
import { dataInitialSelectsOptions } from '../../fields';
import MaximumDiscountUsesBlock from './MaximumDiscountUsesBlock';
import ActiveDatesBlock from './ActiveDatesBlock';
import DiscountCodeBlock from './DiscountCodeBlock';
import PrefixDiscount from './PrefixDiscount';
import DefaultDiscount from './DefaultDiscount';
import ProductQuantityBasedDiscount from './ProductQuantityBasedDiscount';
import ProductQuantityBasedADVDiscount from './ProductQuantityBasedADVDiscount';
import FreeItemDiscount from './FreeItemDiscount';
import BuyOneGetOneDiscount from './BuyOneGetOneDiscount';

interface Props {
  control: Control<DiscountTypes.ItemCreateParams> | undefined;
  watch: UseFormWatch<DiscountTypes.ItemCreateParams>;
  setValue: UseFormSetValue<DiscountTypes.ItemCreateParams>;
  initialData: DiscountTypes.ItemCreateParams;
  initialSelectsOptions:
    | ReturnType<typeof dataInitialSelectsOptions>
    | undefined;
  selectedDiscount: DiscountTypes.DiscountTypeItem | undefined;
}

const DiscountSettings: React.FC<Props> = (props: Props): JSX.Element => {
  const {
    initialData,
    control,
    watch,
    setValue,
    initialSelectsOptions,
    selectedDiscount,
  } = props;

  return (
    <Stack spacing={2}>
      <DiscountCodeBlock
        control={control}
        watch={watch}
        initialData={initialData}
      />

      {selectedDiscount?.namespace === 'product-discount-prefix' && (
        <PrefixDiscount control={control} setValue={setValue} />
      )}

      {selectedDiscount?.namespace === 'Product Qunatity Based Discount' && (
        <ProductQuantityBasedDiscount
          control={control}
          setValue={setValue}
          initialSelectsOptions={initialSelectsOptions}
          watch={watch}
        />
      )}

      {selectedDiscount?.namespace === 'discount_by_product_and_quantity' && (
        <ProductQuantityBasedADVDiscount
          control={control}
          setValue={setValue}
          initialSelectsOptions={initialSelectsOptions}
          watch={watch}
        />
      )}

      {selectedDiscount?.namespace === 'free-gift-and-cart-value-combo' && (
        <FreeItemDiscount
          control={control}
          setValue={setValue}
          initialSelectsOptions={initialSelectsOptions}
          watch={watch}
        />
      )}

      {selectedDiscount?.namespace ===
        'apply_quantity_based_free_item_discount' && (
        <BuyOneGetOneDiscount
          control={control}
          setValue={setValue}
          initialSelectsOptions={initialSelectsOptions}
          watch={watch}
        />
      )}

      {!selectedDiscount && (
        <DefaultDiscount
          control={control}
          watch={watch}
          setValue={setValue}
          initialSelectsOptions={initialSelectsOptions}
        />
      )}

      <MaximumDiscountUsesBlock control={control} setValue={setValue} />
      <ActiveDatesBlock control={control} watch={watch} setValue={setValue} />
      <ChannelBlock control={control} watch={watch} setValue={setValue} />
    </Stack>
  );
};

export default DiscountSettings;
